<template>
    <div class="personal">
        <div class="pageTitle">
            账号信息<span v-if="pageData.settingShow" @click="pageData.settingShow = false">编辑</span>
        </div>
        <div class="container_" v-if="pageData.settingShow">
            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    姓名
                </div>
                <div class="content_">
                    {{ pageData.userInformation.name }}
                </div>
            </div>
            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    性别
                </div>
                <div class="content_">
                    {{ pageData.userInformation.sex == 1 ? '男' : '女' }}
                </div>
            </div>
            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    民族
                </div>
                <div class="content_">
                    {{ pageData.userInformation.ethnic }}
                </div>
            </div>
            <!-- <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    账号类型
                </div>
                <div class="content_">
                    个人
                </div>
            </div> -->
            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    出生日期
                </div>
                <div class="content_">
                    {{ pageData.userInformation.birthDate }}
                </div>
            </div>
            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    国家/地区
                </div>
                <div class="content_">
                    <div class="selectFourWap">
                        <div>
                            {{ pageData.userInformation.nation }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    具体地址
                </div>
                <div class="content_">
                    {{ pageData.userInformation.address }}
                </div>
            </div>

            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    证件号
                </div>
                <div class="content_">
                    {{ pageData.userInformation.idNumber }}
                </div>
            </div>

            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    证件签发日期
                </div>
                <div class="content_">
                    {{ pageData.userInformation.issueDate }}
                </div>
            </div>

            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    证件失效日期
                </div>
                <div class="content_">
                    {{ pageData.userInformation.expirationDate == '2300-01-01' ? '永久' : pageData.userInformation.expirationDate}}
                </div>
            </div>

            <div class="containerItem">
                <div class="title_">
                    <span>*</span>
                    身份证照片
                </div>
                <div class="content_">
                    <div class="idCardWap">
                        <div class="item">
                            <div class="img_">
                                <img :src="pageData.userInformation.cardHoldImage" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="img_">
                                <img :src="pageData.userInformation.cardFrontImage" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="img_">
                                <img :src="pageData.userInformation.cardBackImage" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container_" v-else>
            <el-form ref="form" :model="pageData.personalForm" label-width="74px">
                <el-form-item label="姓名">
                    <el-input v-model="pageData.personalForm.name"></el-input>
                </el-form-item>

                <el-form-item label="性别">
                    <el-radio-group v-model="pageData.personalForm.sex">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="民族">
                    <el-input v-model="pageData.personalForm.ethnic"></el-input>
                </el-form-item>
                <el-form-item label="出生日期">
                    <el-date-picker v-model="pageData.personalForm.birthDate" type="date" style="width: 100%"
                        placeholder="选择日期" format="YYYY/MM/DD" value-format="YYYY-MM-DD">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="国家/地区">
                    <div class="selectFourWap">
                        <div>
                            <el-input v-model="pageData.personalForm.nation" placeholder="国家"></el-input>
                        </div>
                        <div>
                            <el-input v-model="pageData.personalForm.province" placeholder="省"></el-input>
                        </div>
                        <div>
                            <el-input v-model="pageData.personalForm.city" placeholder="市"></el-input>
                        </div>
                        <div>
                            <el-input v-model="pageData.personalForm.district" placeholder="区"></el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="具体地址">
                    <el-input v-model="pageData.personalForm.address"></el-input>
                </el-form-item>
                <el-form-item label="证件类型">
                    <div class="formBody">
                        <el-select v-model="pageData.personalForm.cardType" placeholder="证件类型">
                            <el-option label="居民身份证" :value="1"></el-option>
                            <el-option label="营业执照" :value="3"></el-option>
                            <el-option label="居住证" :value="4"></el-option>
                            <el-option label="护照" :value="9"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="证件号">
                    <el-input v-model="pageData.personalForm.idNumber" @blur="onInputBlur"></el-input>
                </el-form-item>
                <el-form-item label="证件签发日期">
                    <el-date-picker v-model="pageData.personalForm.issueDate" type="date" style="width: 100%"
                        format="YYYY/MM/DD" value-format="YYYY-MM-DD"></el-date-picker>
                </el-form-item>
                <el-form-item label="证件失效日期">
                    <div class="expiryDateWap">
                        <div>
                            <el-radio-group v-model="pageData.cardEndTimtType"
                                @change="radioSetting(pageData.cardEndTimtType)">
                                <el-radio label="1">永久</el-radio>
                                <el-radio label="2">有效期</el-radio>
                            </el-radio-group>
                        </div>
                        <div v-show="pageData.cardEndTimtType == '2'">
                            <el-date-picker v-model="pageData.personalForm.expirationDate" type="date"
                                style="width: 100%" format="YYYY/MM/DD" value-format="YYYY-MM-DD">
                            </el-date-picker>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="身份证照片">
                    <div class="idCardWap">
                        <div class="item">
                            <div class="img_" v-if="pageData.cardHoldImageView">
                                <input type="file" accept="image/*" @change="inputFile($event, 'cardHoldImage')" />
                                <img :src="pageData.cardHoldImageView" alt="" />
                            </div>
                            <div class="img_" v-else>
                                <input type="file" accept="image/*" @change="inputFile($event, 'cardHoldImage')" />
                                <img src="@/assets/images/idCardType1.png" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="img_" v-if="pageData.cardFrontImageView">
                                <input type="file" accept="image/*" @change="inputFile($event, 'cardFrontImage')" />
                                <img :src="pageData.cardFrontImageView" alt="" />
                            </div>
                            <div class="img_" v-else>
                                <input type="file" accept="image/*" @change="inputFile($event, 'cardFrontImage')" />
                                <img src="@/assets/images/idCardType2.png" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="img_" v-if="pageData.cardBackImageView">
                                <input type="file" accept="image/*" @change="inputFile($event, 'cardBackImage')"
                                    value-format="yyyy-MM-dd HH:mm:ss" />
                                <img :src="pageData.cardBackImageView" alt="" />
                            </div>
                            <div class="img_" v-else>
                                <input type="file" accept="image/*" @change="inputFile($event, 'cardBackImage')"
                                    value-format="yyyy-MM-dd HH:mm:ss" />
                                <img src="@/assets/images/idCardType3.png" />
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="buttonView">
                <div @click="pageData.settingShow = true">取消</div>

                <div @click="updateUserPersonalAuthenticationFun">确认</div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";
import { reactive, onMounted } from "vue";
import { useStore } from "vuex";

import {
    updateUserPersonalAuthentication,
    getUserInfo
} from "../../api/interfaceList.js";

export default {

    setup() {

        // const store = useStore();

        let pageData = reactive({
            userCode: JSON.parse(Cookies.get("userInformation")).userCode,
            cardEndTimtType: "1",
            userInformation: '',
            formData: new FormData(),
            settingShow: true,
            personalForm: {
                userCode: JSON.parse(Cookies.get("userInformation")).userCode,
                name: "",
                sex: "",
                ethnic: "",
                birthDate: "",
                nation: "",
                province: "",
                city: "",
                district: "",
                address: "",
                idNumber: "",
                issueDate: "",
                cardType: "",
                expirationDate: "",
                channel: "ly",
            },
            cardHoldImage: "",
            cardFrontImage: "",
            cardBackImage: "",
            cardHoldImageView: "",
            cardFrontImageView: "",
            cardBackImageView: "",
        })

        function radioSetting(e) {
            let myDate = new Date((new Date).getTime() + 8*60*60*1000)
            let time = myDate.toJSON().split('T').join(' ').substr(0,19)
            e == 1 ? pageData.personalForm.expirationDate = "2300-01-01" : pageData.personalForm.expirationDate = time.slice(0, time.length - 9)
        }

        function getUserInfoFun() {
            getUserInfo({
                usercode: pageData.userCode
            }).then(res => {
                res.data.pauthenticationDTO.expirationDate == '2300-01-01' ? pageData.cardEndTimtType = '1' :  pageData.cardEndTimtType = '2'
                pageData.userInformation = res.data.pauthenticationDTO
                pageData.personalForm = res.data.pauthenticationDTO
                pageData.cardHoldImageView = res.data.pauthenticationDTO.cardHoldImage
                pageData.cardFrontImageView = res.data.pauthenticationDTO.cardFrontImage
                pageData.cardBackImageView = res.data.pauthenticationDTO.cardBackImage
            })
        }

        function updateUserPersonalAuthenticationFun() {
            pageData.personalForm.cardHoldImage.substr(0, 4) == "http" ? delete pageData.personalForm["cardHoldImage"] : ''
            pageData.personalForm.cardFrontImage.substr(0, 4) == "http" ? delete pageData.personalForm["cardFrontImage"] : ''
            pageData.personalForm.cardBackImage.substr(0, 4) == "http" ? delete pageData.personalForm["cardBackImage"] : ''
            for (var key in pageData.personalForm) {
                pageData.formData.append(key, pageData.personalForm[key]);
            }
            pageData.formData.append('userCode', JSON.parse(Cookies.get("userInformation")).userCode)
            // pageData.formData.append('uniqueCode', JSON.parse(Cookies.get("userInformation")).userCode)
            updateUserPersonalAuthentication(pageData.formData).then(res => {
                pageData.formData = new FormData
                pageData.cardHoldImage = ""
                pageData.cardFrontImage = ""
                pageData.cardBackImage = ""
                if (res.code == 1) {
                    pageData.settingShow = true
                    ElMessage({
                        message: res.message,
                        type: "success",
                    })
                    this.getUserInfoFun()
                } else {
                    pageData.cardHoldImageView = ''
                    pageData.cardFrontImageView = ''
                    pageData.cardBackImageView = ''
                    pageData.personalForm.cardHoldImage = 'http'
                    pageData.personalForm.cardFrontImage = 'http'
                    pageData.personalForm.cardBackImage = 'http'
                    ElMessage({
                        message: res.message,
                        type: "warning",
                    });
                }
            })
        }
        function onInputBlur() {
            let regular =
                /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if (!regular.test(pageData.personalForm.idNumber)) {
                pageData.personalForm.idNumber = "";
                ElMessage({
                    message: "身份证格式错误",
                    type: "success",
                });
                return false;
            }
        }

        function inputFile(e, type) {
            let files = e.target.files[0];
            if (!files.type.match(/.jpg|.png|.jpeg/i)) {
                alert("图片格式错误,请上传png/jpg/jpeg格式的图片!");
                return;
            }
            if (type == "cardHoldImage") {
                pageData.formData.append("cardHoldImage", files); //添加Fail类型的图片信息的参数
            } else if (type == "cardFrontImage") {
                pageData.formData.append("cardFrontImage", files); //添加Fail类型的图片信息的参数
            } else if (type == "cardBackImage") {
                pageData.formData.append("cardBackImage", files); //添加Fail类型的图片信息的参数
            }
            var reader = new FileReader();
            reader.readAsDataURL(files);
            reader.onload = () => {
                if (type == "cardHoldImage") {
                    pageData.cardHoldImageView = reader.result;
                } else if (type == "cardFrontImage") {
                    pageData.cardFrontImageView = reader.result;
                } else if (type == "cardBackImage") {
                    pageData.cardBackImageView = reader.result;
                }
            };
            reader.onerror = function () {
            };
        }

        onMounted(() => {
            getUserInfoFun()
        })
        return {
            pageData,
            updateUserPersonalAuthenticationFun,
            onInputBlur,
            inputFile,
            getUserInfoFun,
            radioSetting
        }
    }
}

</script>
<style lang="scss" scoped>
.personal {
    width: 650px;
    padding-bottom: 100px;
    box-sizing: border-box;

    .pageTitle {
        font-size: 16px;
        font-family: AlibabaPuHuiTiM;
        color: #303133;
        margin-bottom: 24px;
        font-weight: 700;
        display: flex;
        align-items: center;

        span {
            font-size: 13px;
            font-family: AlibabaPuHuiTiM;
            color: #008AEA;
            margin-left: 8px;
            cursor: pointer;
        }
    }

    .container_ {

        // width: 506px;
        padding: 16px 0 100px;
        box-sizing: border-box;

        .buttonView {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 40px;

            div {
                cursor: pointer;
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                font-family: AlibabaPuHuiTiM;
                text-align: center;
                border-radius: 8px;

                // width: 240px;
                // color: #FFFFFF;
                // background: #008AEA;
            }

            div:nth-of-type(1) {
                width: 120px;
                color: #909399;
                border: 1px solid #C0C4CC;
                margin-right: 72px;
            }

            div:nth-of-type(2) {
                width: 240px;
                color: #FFFFFF;
                background: #008AEA;
            }
        }

        .containerItem {
            display: flex;
            align-items: center;
            margin-bottom: 28px;

            .title_ {
                width: 100px;
                height: 24px;
                font-size: 12px;
                font-family: AlibabaPuHuiTiR;
                color: #303133;
                display: flex;
                align-items: center;

                span {
                    color: #CC3F1F;
                    margin-right: 5px;
                }
            }

            .content_ {
                font-size: 13px;
                font-family: AlibabaPuHuiTiR;
                color: #606266;
            }
        }

        .idCardWap {
            width: 452px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item {
                width: 144px;
                height: 96px;
                overflow: hidden;

                .img_ {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    position: relative;
                    justify-content: center;

                    input {
                        width: 100%;
                        height: 100%;
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 1;
                        opacity: 0;
                    }

                    img {
                        height: 100%;
                        //   position: absolute;
                        //   top: 0;
                        //   left: 0;
                    }
                }
            }
        }

        .expiryDateWap {
            display: flex;
            justify-content: space-between;
            align-items: center;

            div:nth-of-type(1) {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-right: 10px;
            }

            div:nth-of-type(2) {
                width: 250px;
            }
        }

        .selectFourWap {
            display: flex;
            justify-content: space-between;
            align-items: center;

            div {
                width: 100px;
                margin-right: 10px;
            }

            div:last-of-type {
                margin: 0;
            }
        }

    }

    .idCardWap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .item {
            width: 144px;
            height: 96px;

            .img_ {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                position: relative;
                justify-content: center;

                input {
                    width: 100%;
                    height: 100%;
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 1;
                    opacity: 0;
                }

                img {
                    height: 100%;
                    width: auto !important;
                    //   position: absolute;
                    //   top: 0;
                    //   left: 0;
                }
            }
        }
    }

    .expiryDateWap {
        display: flex;
        justify-content: space-between;
        align-items: center;

        div:nth-of-type(1) {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        div:nth-of-type(2) {
            width: 250px;
        }
    }

    .selectFourWap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        div {
            width: 110px;
        }
    }
}
</style>


